import React from "react";

const BranchButton = ({ title, clicked, index, selected }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  // Selected item is a filled blue pill with white text; unselected items are
  // plain text that subtly highlights on hover.
  const background = selected ? "#0065FD" : isHovered ? "#ECF4FF" : "transparent";

  return (
    <div
      onClick={() => clicked(index)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="rounded-[17px] px-3 py-[5px] cursor-pointer whitespace-nowrap"
      style={{ backgroundColor: background }}
    >
      <span className={`font-OpenSansMedium text-[14px] ${selected ? "text-white" : "text-titleColor"}`}>{title}</span>
    </div>
  );
};

export default BranchButton;
